export const webshop = {
  seo: {
    title: 'Online webshop voor restaurants & horecazaken – Afhaal & bezorging | Bistroo',
    description: 'Een gepersonaliseerde webshop voor jouw restaurant of horecazaak, volledig aanpasbaar naar jouw wensen. Probeer 30 dagen gratis.',
  },
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'webshop',
      pt3: 'op maat gemaakt voor restaurants',
    },
    description:
      'Maak het jezelf makkelijk met de Bistroo webshop. Onze klanten besparen tijd, werken efficiënter én zien hun inkomsten groeien.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Verhoog je omzet, verlaag je kosten',
      text: 'Een goed geoptimaliseerde webshop kan zorgen voor meer bestellingen én hogere orderwaarden vergeleken met traditionele bestelmethoden. Bespaar tot 20% op operationele kosten en tijd, en verwerk moeiteloos meer bestellingen dan ooit tevoren.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Betaal pas als je de meerwaarde hebt geproefd',
      text: 'Van volledig gratis pakketten tot toegankelijke maandabonnementen, kies welk prijspakket bij jouw smaak past en ontdek zelf wat de producten van Bistroo voor je kunnen doen. Dankzij een gratis proefperiode probeer je het eenvoudig uit, zonder dat je meteen vastzit aan een contract.',
      cta: '',
    },
    paragraph_3: {
      title: 'Bestel via Google',
      text: 'Wij zetten je letterlijk op de kaart. We optimaliseren je webshop, voor Google Search en Google Maps. Wij volgen de innovaties op het gebied van online verkeer en zorgen dat jouw webshop altijd makkelijk te vinden blijft. Deze optie is inclusief in alle Bistroo-pakketten.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Pas aan naar jouw merk',
      text: 'Een compleet white-label pakket is beschikbaar, waarmee je de volledige klant ervaring in de stijl van jouw restaurant kunt vormgeven. Van de landingspagina tot het bestel- en bevestigingsproces. Alles in jouw unieke stijl.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Verwerk bestellingen moeiteloos.',
        text: 'Beheer elke bestelling tot in de puntjes, altijd en overal, vanaf elk apparaat. Print bonnen zoals jij het wilt, op elk type printer.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel je favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Upselling opties.',
        text: 'Stel uitgebreide up-sell opties in en verhoog de gemiddelde orderwaarde van je bestellingen.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Groei je omzet.',
        text: 'Tot wel 30% meer omzet met een geoptimaliseerde webshop.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Kortingen en loyaliteit.',
        text: 'Stel promoties, kortingen en loyaliteitsbeloningen in voor je terugkerende klanten.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Sinds we met Bistroo werken zien we onze to-go bestellingen oplopen gestegen, superfijn! Wanneer iets niet goed loopt, dan is Bistroo goed bereikbaar en lossen ze het direct op."',
    cta: 'Lees volledig verhaal',
    name: 'Marieke van Loon',
    job_title: 'Eigenaresse Xtra-social',
  },
  faq: {
    title_pt1: 'Alles over de',
    title_pt2: 'Bistroo Webshop',
    items: [
      { q: 'Hoe maak ik een Bistroo webshop aan?', a: 'Registreer je gratis via merchant.bistroo.nl. Na je aanmelding doorloop je een korte setup waarbij je je menu, openingstijden en bezorggebieden invoert. Binnen enkele minuten is je webshop live.' },
      { q: 'Kan ik de webshop volledig in mijn eigen huisstijl zetten?', a: 'Ja. Je kiest je eigen kleuren, laadt je logo en profielfoto op en stelt een welkomstbericht in. Wil je helemaal los gaan? Met het white-label pakket beheer je de volledige klantervaring in jouw merkstijl, van de landingspagina tot de orderbevestiging.' },
      { q: 'Welke betaalmethoden kunnen mijn klanten gebruiken?', a: 'Via Bistroo kunnen klanten betalen met iDEAL, creditcard, Apple Pay, Google Pay en meer. Je koppelt je eigen betaalprovider (Mollie of Stripe) en betalingen komen direct op jouw rekening terecht.' },
      { q: 'Hoe word ik gevonden via Google?', a: 'Bistroo optimaliseert je webshop voor Google Search en Google Maps. Via Order with Google verschijnt er bovendien een bestelknop direct in de zoekresultaten, zodat klanten zonder omwegen bij jou bestellen.' },
      { q: 'Kan ik kortingen en loyaliteitsacties instellen?', a: 'Ja. In de Bistroo Manager stel je eenvoudig kortingscodes, tijdelijke acties en loyaliteitsbeloningen in. Deze zijn direct zichtbaar in je webshop.' },
      { q: 'Is de webshop te koppelen aan mijn kassasysteem?', a: 'Ja. Bistroo integreert met de meest gebruikte kassasystemen zoals Lightspeed, unTill, M+ Kassa, WinstonPOS en Cashdesk. Bestellingen komen automatisch als ticket binnen in je kassa.' },
      { q: 'Hoe stel ik mijn bezorg- en afhaalgebieden in?', a: 'Via de Bistroo Manager teken je je bezorggebieden haarscherp in op Google Maps. Per zone stel je aparte bezorgkosten en minimumorderbedragen in. Aanpassingen zijn direct live.' },
      { q: 'Wat kost de Bistroo webshop?', a: 'Bistroo heeft een gratis pakket waarmee je direct kunt starten. Wil je meer functies, dan zijn er betaalde maandpakketten beschikbaar. Er zijn geen opstartkosten en geen langlopende contracten.' },
      { q: 'Kan ik meerdere locaties beheren vanuit één account?', a: 'Ja. Via de Bistroo Manager beheer je al je vestigingen centraal. Per locatie stel je aparte menu\'s, openingstijden en bezorggebieden in.' },
      { q: 'Hoe lang duurt het om mijn webshop live te zetten?', a: 'Bij de meeste restaurants is de webshop binnen een dag operationeel. Bistroo biedt onboarding-ondersteuning zodat je snel en foutloos van start gaat.' },
    ],
  },
}
